<template>
    <h2 class="tw-text-xs sm:tw-text-sm tw-text-gray-400 tw-font-medium tw-font-title">
        <slot></slot>
    </h2>
</template>

<script setup lang="ts"></script>

<style scoped></style>
